export default class InvalidBusinessProfileRequestedError extends Error {
  constructor(message: string) {
    super(message);
  }
}
